import { Component, OnInit, Input, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { AssetUrlService } from 'src/app/services/basic/asset-url.service';

import { HttpClient } from '@angular/common/http';
import { AlertController, ModalController } from '@ionic/angular';
import { InfozonemodalComponent } from 'src/app/components/infozonemodal/infozonemodal.component';
import { VideomodalComponent } from 'src/app/components/videomodal/videomodal.component';

@Component({
    selector: 'app-smblocktileitem',
    templateUrl: './smblocktileitem.component.html',
    styleUrls: ['./smblocktileitem.component.scss'],
    standalone: false
})
export class SmblocktileitemComponent implements OnInit {
  @Input() b: any;
  public basepath = '';

  private assetUrl = inject(AssetUrlService);

  constructor(
    public data: DataService,
    public router: Router,
    public route: ActivatedRoute,
    public http: HttpClient,
    public alertController: AlertController,
    public modalController: ModalController
  ) {
  }

  ionViewWillEnter() {
    this.basepath = this.assetUrl.getMediaBase();
  }

  ngOnInit() {
    this.basepath = this.assetUrl.getMediaBase();
  }

  isboxVisited() {
    return this.data.isboxVisited(this.b.id, this.route.snapshot.paramMap.get("module"));
  }

  async navigate() {
    let id = this.route.snapshot.paramMap.get("id");
    let module_id = this.route.snapshot.paramMap.get("module");
    this.data.visitbox(module_id, this.b.id);

    console.log('/smpage/' + this.b.nav_id + '/' + module_id)
    if (this.b.nav_id) {
      this.router.navigateByUrl('/smpage/' + this.b.nav_id + '/' + module_id);
      return;
    }
    
    if (this.b.video) {
      let that = this
      let video = this.b.video;
      const modal = await this.modalController.create({
        component: VideomodalComponent,
        animated: false,
        htmlAttributes: { 'aria-label': 'Video: ' + (video?.title || '') },
        componentProps: {
          video: video,
          basepath: that.assetUrl.getMediaBase()
        }
      });

      let payload = {
        token: this.data.token,
        title: 'Open video ' + video.title,
        pathway_id: that.data.pathway ? that.data.pathway.id : '',
        condition: (that.data.pathway && that.data.pathway.condition) ? that.data.pathway.condition.id : ''
      };
      this.data.apiPost('userappnav', this.data.payloadMiddleware(payload)).subscribe({
        next: function(response:any) {
          // console.log(response);
        },
        error: function(response) {
          // console.log(arguments);
        }
      })

      return await modal.present();
    }

    if (this.b.infozone) {
      let infozone = this.b.infozone;
      let that = this
      const modal = await this.modalController.create({
        component: InfozonemodalComponent,
        animated: false,
        htmlAttributes: { 'aria-label': 'Info: ' + (infozone?.title || '') },
        componentProps: {
          infozone: infozone,
          basepath: that.assetUrl.getMediaBase()
        }
      });

      let payload = {
        token: this.data.token,
        title: 'Open infozone ' + infozone.id,
        pathway_id: that.data.pathway ? that.data.pathway.id : '',
        condition: (that.data.pathway && that.data.pathway.condition) ? that.data.pathway.condition.id : ''
      };
      this.data.apiPost('userappnav', this.data.payloadMiddleware(payload)).subscribe({
        next: function(response:any) {
          // console.log(response);
        },
        error: function(response) {
          // console.log(arguments);
        }
      })

      return await modal.present();

    }


  }

  safeURL(item) {
    return encodeURI(item);
  }

  mediaUrl(path: string): string {
    return this.assetUrl.mediaUrl(path);
  }

}
